import React, { useEffect, useContext } from "react";
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import Select from 'react-select';
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import { ValidSelect } from "beaktShared/helpers/validselect";
import Tooltip from "@material-ui/core/Tooltip";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";


//icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Close from "@material-ui/icons/Close";
import Check from "@material-ui/icons/Check";
import Search from "@material-ui/icons/Search";

//services
import { MaskCEP, MaskCel, MaskDate, formateDate, convertDate } from "beaktShared/helpers/masks";
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { noCaseSensitive } from "beaktShared/helpers/extras";

const useStyles = makeStyles(styles);

export default function RelatoriosPersonalizadosForm({ addItem, item, handleView, loading }) {

  const classes = useStyles();
  const { t } = useTranslation();
  const { register, handleSubmit, setValue, setError, errors, clearError } = useForm({ mode: "onChange" });
  const session = useContext(SessionContext);

  const [notification, setNotification] = React.useState({
    show: false,
    color: 'info',
    message: ''
  });
  const showNotification = (message, color) => {
    setNotification({
      show: true,
      color: color,
      message: message
    });
    setTimeout(function () {
      setNotification(prev => ({ ...prev, show: false }));
    }, 6000);
  };
  const [relatoriopersonalizado_Id, setrelatoriopersonalizado_Id] = React.useState(0);

  useEffect(() => {
    loadSelectEstabelecimentos();
    LoadCaminhoVirtual();

  }, []);

  useEffect(() => {
    LoadDadosItem(item);
  }, [item]);

  //busca o path virtual do sistema para fazer o download de arquivo
  const [caminhoVirtual, setcaminhoVirtual] = React.useState("");
  const LoadCaminhoVirtual = () => {
    let endpointPath = "setupsistema/bycaminhovirtual"
    UseGetApiSimple(endpointPath, 0).then(result => {
      if (result.status !== 200) {
        showNotification(result.message, 'danger');
        return false;
      }
      setcaminhoVirtual(result.data);
    });
  }
  //lista para carregar/armazenar arquivos importados
  const [listFiles, set_listFiles] = React.useState([]);

  const LoadDadosItem = (item) => {
    if (!item.relatorioPersonalizado_Id)
      return;

    // setValue('relatorioPersonalizado_Id', (item.relatorioPersonalizado_Id === null ? 0 : item.relatorioPersonalizado_Id));
    setrelatoriopersonalizado_Id((item.relatorioPersonalizado_Id === null ? 0 : item.relatorioPersonalizado_Id));
    setValue('nomerelatorio', item.nomeRelatorio);
    setValue('dataDe', formateDate(item.dataDe));
    setValue('dataAte', formateDate(item.dataAte));
    setValue('status', item.status);
    setAtivoCheckbox(item.status);

    item.relatoriosPersonalizadosAnexos.map(m => listFiles.push(m));

  }
  // CAMPO PARA SETAR SE O RELATORIO ESTA ATIVO OU INATIVO
  const [ativoCheckbox, setAtivoCheckbox] = React.useState(true);
  // CAMPOS PARA CARREGAR E SETAR OS ESTABELECIMENTOS
  const [listSelectEstabelecimentos, setlistSelectEstabelecimentos] = React.useState([]);
  const [loadingSelectEstabelecimentos, setloadingSelectEstabelecimentos] = React.useState(false);
  const [estabelecimento, setestabelecimento] = React.useState(null);
  const loadSelectEstabelecimentos = () => {
    setloadingSelectEstabelecimentos(true);
    const endPoint = "estabelecimentos/ativos/byfranquia/" + session.franquiaId;
    UseGetApiSimple(endPoint, 0).then(result => {
      if (result.status !== 200) {
        //showNotification(result.message,'danger');  
        setloadingSelectEstabelecimentos(false);
        return false;
      }
      let todos = {
        estabelecimentoId: null,
        descricao: "Todos"
      };

      let lista_estabelecimentos = [todos, ...result.data];

      setlistSelectEstabelecimentos(lista_estabelecimentos);
      setloadingSelectEstabelecimentos(false);
      return true;
    });
  }
  const handleEstabelecimentoChange = event => {
    let value = event
    setestabelecimento(value);
    setValue("estabelecimento", value);
    if (value !== "")
      clearError("estabelecimento");
  };
  // handle para importar o PDF
  const [filedata, set_filedata] = React.useState(null);

  const handleChangeImportarArquivo = (event) => {
    if (event.target.files.length > 0) {
      set_filedata(event.target.files[0]);
      clearError("arquivo");
    }
  }
  const handleClickConfirmarImportacao = () => {

    if (filedata === null)
      return setError("arquivo", "required")

    if (estabelecimento === null)
      return setError("estabelecimento", "required")

    // verifica se o tipo do arquivo é PDF
    if (!filedata.type.includes("application/pdf")) {
      setError("arquivo", "", t('information_message.invalid_file_the_extension_must_be_PDF'));
      return;
    }
    else
      clearError("arquivo");

    // validações para não adicionar registros duplicados.
    if ((listFiles.filter(obj => { return obj.estabelecimentoId == null })).length > 0) {
      showNotification("Já foram adicionados Todos estabelecimentos á lista!", 'info');
      return;
    }
    if (listFiles.length > 0 && estabelecimento.estabelecimentoId == null) {
      showNotification("A lista já contém estabelecimentos! \n Para incluir Todos de uma só vez, remova os existentes!", 'info')
      return;
    }
    if ((listFiles.filter(obj => { return obj.estabelecimentoId === estabelecimento.estabelecimentoId })).length > 0) {
      showNotification("Estabelecimento já adicionado á lista!", 'info');
      return;
    }

    const fileReader = new FileReader();
    fileReader.onload = function (oFREvent) {
      //constroi os campos do array
      let _file = {
        relatorioPersonalizado_Id: relatoriopersonalizado_Id,
        relatorioPersonalizadoAnexo_Id: 0,
        estabelecimento: estabelecimento,
        estabelecimentoId: estabelecimento.estabelecimentoId,
        arquivo: (oFREvent.target.result === null ? "" : oFREvent.target.result.replace("data:application/pdf;base64,", "")),
        nomeArquivo: filedata.name,
        caminhoArquivo: filedata.name
      }

      let _listfiles = [];
      listFiles.map(m => _listfiles.push(m));

      _listfiles.push(_file);// Agora _listfiles vai ter tudo que ja foi importado mais a nova importação de _file

      set_listFiles(_listfiles);// agora seta a lista da tela com todas importações
    }
    fileReader.readAsDataURL(filedata);
  }
  //deleta arquivo da tabela
  const handleDelete = row => {
    let listAtualizada = listFiles.filter(obj => {
      return obj.estabelecimentoId != row.estabelecimentoId
    });

    set_listFiles(listAtualizada);
  };
  //faz download do arquivo selecionado
  const handleDownload = row => {
    window.open(caminhoVirtual + row.caminhoArquivo, "_blank");

  };

  const onSubmit = data => {

    if (listFiles.length === 0) {
      showNotification("O relatório precisa ter pelomenos 1 arquivo importado", 'info');
      return;
    }

    // reconstroi o array para nao mandar o campo estabelecimento pois ele da erro na requisição
    let relatoriosPersonalizadosAnexos = [];
    for (var i in listFiles) {
      relatoriosPersonalizadosAnexos.push({
        relatorioPersonalizado_Id: listFiles[i].relatoriopersonalizado_Id,
        relatorioPersonalizadoAnexo_Id: listFiles[i].relatorioPersonalizadoAnexo_Id,
        estabelecimentoId: listFiles[i].estabelecimentoId,
        arquivo: listFiles[i].arquivo,
        nomeArquivo: listFiles[i].nomeArquivo,
        caminhoArquivo: listFiles[i].caminhoArquivo
      });
    }

    let json_submit = {
      relatorioPersonalizado_Id: relatoriopersonalizado_Id,
      nomeRelatorio: data.nomerelatorio,
      dataDe: convertDate(data.dataDe),
      dataAte: convertDate(data.dataAte),
      status: ativoCheckbox,
      criadoPor: session.id,
      franquiaId: session.franquiaId,
      relatoriosPersonalizadosAnexos: relatoriosPersonalizadosAnexos
    };
    addItem(json_submit);
  }

  const handleViewForm = () => {
    handleView();
  };

  //Columns da tabela com os arquivos importados para cada estabelecimento
  const columnsProps = [
    {
      Header: t('label.establishment'),
      accessor: "estabelecimento.descricao",
      Cell: (row) => {
        if (row.original.estabelecimento === null)
          return "Todos"
        else
          return row.original.estabelecimento.descricao
      },
    },
    {
      Header: t('label.file'),
      accessor: "nomeArquivo"
    }
  ];
  const columnsAcao = [
    {
      Header: t('label.actions'),
      Cell: row => (
        <div className="actions-right">
          {relatoriopersonalizado_Id != 0 && row.original.relatorioPersonalizadoAnexo_Id != 0 &&
            <Button
              justIcon
              round
              simple
              color="info"
              className="info"
              onClick={() => handleDownload(row.original)}
            >
              <Tooltip title={t('label.detail')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Search />
              </Tooltip>
            </Button>
          }
          {" "}
          <Button
            justIcon
            round
            simple
            color="danger"
            className="remove"
            onClick={() => handleDelete(row.original)}
          >
            <Close />
          </Button>{" "}

        </div>
      ),
      sortable: false,
      filterable: false
    }
  ];

  const columns = [...columnsProps, ...columnsAcao]

  return (

    <div className="maxContent">
      <Snackbar
        place="tr"
        color={notification.color}
        message={notification.message}
        open={notification.show}
        closeNotification={() => setNotification(prev => ({ ...prev, show: false }))}
        close
      />
      <form onSubmit={handleSubmit(onSubmit)}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader>
                <CardIcon color="primary">
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  {t('information_message.registration_custom_reports')}
                  {/* <input className={classes.hidden} defaultValue={intialValues.id} name="id" ref={register} /> */}
                </h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl fullWidth className={classes.formControl}>
                      <TextField
                        error={errors.nomerelatorio ? true : false}
                        label={t('label.report_name') + " *"}
                        variant="outlined"
                        inputRef={register({ required: true })}
                        name="nomerelatorio"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ maxLength: 150 }}
                      />
                      <FormHelperText className={classes.labelRootError}>
                        {errors.nomerelatorio && <span>{t('label.required')}</span>}
                      </FormHelperText>
                      <br></br>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4}>
                    <FormControl fullWidth className={classes.formControl}>
                      <TextField
                        error={errors.dataDe ? true : false}
                        label={t('label.ini_date') + " *"}
                        variant="outlined"
                        inputRef={register({ required: true })}
                        name="dataDe"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ inputComponent: MaskDate }}
                      />
                      <FormHelperText className={classes.labelRootError}>
                        {errors.dataDe && <span>{t('label.required')}</span>}
                      </FormHelperText>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4}>
                    <FormControl fullWidth className={classes.formControl}>
                      <TextField
                        error={errors.dataAte ? true : false}
                        label={t('label.end_date') + " *"}
                        variant="outlined"
                        inputRef={register({ required: true })}
                        name="dataAte"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ inputComponent: MaskDate }}
                      />
                      <FormHelperText className={classes.labelRootError}>
                        {errors.dataAte && <span>{t('label.required')}</span>}
                      </FormHelperText>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          tabIndex={-1}
                          checked={ativoCheckbox}
                          onClick={event => { setAtivoCheckbox(event.target.checked) }}
                          checkedIcon={<Check className={classes.checkedIcon} />}
                          // icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked,
                            root: classes.checkRoot
                          }}
                          name="status"
                          inputRef={register}
                        />
                      }
                      classes={{
                        label: classes.label,
                        root: classes.labelRoot
                      }}
                      label={t('information_message.system_active') + "?"}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <br></br>
                    <div className="subTitulo">
                      <h6>{t('label.attach_report')} </h6>
                    </div>
                  </GridItem>
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                      <div style={{ border: '1px dashed #ccc', padding: '20px' }}>
                        <GridContainer>
                          <GridItem xs={12} sm={6} md={6}>
                            <h3>{t('label.access_establishments')}</h3>
                          </GridItem>
                        </GridContainer>
                        <br />
                        <GridContainer>
                          <GridItem xs={12} sm={5} md={5}>
                            <FormControl fullWidth className={classes.formControl}>
                              <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>{t('label.establishment') + " *"} </label>
                              <Select
                                classNamePrefix="select"
                                styles={ValidSelect(errors.estabelecimento ? true : false)}
                                isSearchable={true}
                                isLoading={loadingSelectEstabelecimentos}
                                name="estabelecimento"
                                placeholder="Selecione..."
                                options={listSelectEstabelecimentos}
                                value={estabelecimento != null && listSelectEstabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento.estabelecimentoId)}
                                getOptionLabel={({ descricao }) => descricao}
                                getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                onChange={(value) => handleEstabelecimentoChange(value)}
                                ref={() => register({ name: "estabelecimento" })
                                }
                              />
                              {errors.estabelecimento &&
                                <FormHelperText>
                                  <span className="obg"> {t('label.select_an_establishment')} </span>
                                </FormHelperText>}
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={5} md={5}>
                            <FormControl fullWidth className={classes.formControl}>
                              <TextField
                                error={errors.arquivo ? true : false}
                                type="file"
                                label={t('label.file') + " *"}
                                variant="outlined"
                                name="arquivo"
                                InputLabelProps={{ shrink: true }}
                                onBlur={(event) => handleChangeImportarArquivo(event)}
                              />
                              <FormHelperText className={classes.labelRootError}>
                                {errors.arquivo && <span> {errors.arquivo.message}</span>}
                              </FormHelperText>
                            </FormControl>
                          </GridItem>
                          <GridItem xs={12} sm={2} md={2} style={{ textAlign: 'right' }}>
                            <Button color="primary" round onClick={() => handleClickConfirmarImportacao()}>
                              {t('label.import')}
                            </Button>
                          </GridItem>
                        </GridContainer>

                      </div>
                    </GridItem>
                  </GridContainer>
                  {listFiles.length > 0 &&
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                        <div className="subTitulo" style={{ marginTop: '20px' }}>
                          <h6>{t('conciliation.result_import')}</h6>
                        </div>
                        <ReactTable
                          data={listFiles}
                          filterable
                          defaultFilterMethod={noCaseSensitive}
                          columns={columns}
                          filterable
                          defaultFilterMethod = {noCaseSensitive}
                          defaultPageSize={10}
                          minRows={5}
                          showPaginationBottom={true}
                          className="-striped -highlight"
                          previousText={t('button.previous')}
                          nextText={t('button.next')}
                          loadingText={t('label.loading')+"..."}
                          noDataText={t('information_message.no_records_found')+"!"}
                          pageText={t('label.page')}
                          ofText={t('label.of')}
                          rowsText={t('label.rows')}
                        />
                      </GridItem>
                    </GridContainer>
                  }
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
            <Button onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
              {t('button.cancel')}
            </Button>
            <Button type="submit" color="primary" className={classes.updateProfileButton}>
              {t('button.to_save')}
              {loading && <div>{t('label.loading') + "..."}</div>}
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </div >
  );
}
